import { SessionAnalysisType, SessionCatalog } from '../types/SessionAnalysisType';

// Team-singleton sessions have no SessionCatalog entry - label them here.
const SINGLETON_TYPE_NAMES: { [key: number]: string } = {
  [SessionAnalysisType.DISCARDED]: 'Discarded Runs',
  [SessionAnalysisType.DISCARDED_ARCHIVE]: 'Hidden Runs',
  [SessionAnalysisType.FREERIDE_UNSTRUCTURED]: 'Free Ride (Non-Session)',
};

/**
 * Get the session type name from SessionCatalog (or the singleton map)
 */
export const getSessionTypeName = (analysisType: SessionAnalysisType | null): string => {
  if (analysisType === null) {
    return 'Unknown Session Type';
  }

  if (SINGLETON_TYPE_NAMES[analysisType]) {
    return SINGLETON_TYPE_NAMES[analysisType];
  }

  const catalogEntry = SessionCatalog[analysisType as keyof typeof SessionCatalog];
  if (catalogEntry && Array.isArray(catalogEntry) && catalogEntry.length > 0) {
    return catalogEntry[0] as string;
  }

  return 'Unknown Session Type';
};
